import lodash from 'lodash';
import { createSimpleObserver, enforceObservableRules } from '@exodus/atoms';
const { get: getValueAtPath, isEqual } = lodash;
export const createRemoteConfigAtomFactory = ({ remoteConfig }) => ({ defaultValue, ...params }) => {
    if ('path' in params && 'selector' in params) {
        throw new Error('Provide either a path or a selector to get data from remote config - not both.');
    }
    const getValue = (value) => 'path' in params ? getValueAtPath(value, params.path) : params.selector(value);
    const { notify, observe } = createSimpleObserver();
    const get = async () => {
        const data = await remoteConfig.getAll();
        return getValue(data);
    };
    const set = async () => {
        throw new Error('remoteConfig is read-only');
    };
    remoteConfig.on('sync', async ({ current }) => {
        const data = getValue(current);
        return notify(data);
    });
    const observeDistinct = (callback) => observe(function (value) {
        if (isEqual(this.lastValue, value))
            return;
        this.lastValue = value;
        callback(value);
    }.bind({}));
    return enforceObservableRules({
        get,
        set,
        observe: observeDistinct,
        defaultValue,
    });
};
